import { ToDoItemLinkType } from "ui/Scripts/source/models/enums";

export interface IFrontToDoItem {
    id: string;
    title: string;
    amount: number;
    important: boolean;
    linkType: ToDoItemLinkType;
}

export class FrontToDoItem implements IFrontToDoItem {
    id: string;
    title: string;
    amount: number;
    important: boolean;
    linkType: ToDoItemLinkType;

    constructor();
    constructor(obj: IFrontToDoItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.title = obj && obj.title || "";
        this.amount = obj && obj.amount || 0;
        this.important = obj && obj.important || false;
        this.important = obj && obj.important || false;
        this.linkType = obj && obj.linkType || ToDoItemLinkType.None;
    }
}